import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AdminAuthCtx = createContext(null);

export const AdminAuthProvider = ({ children }) => {
    const [token, setToken] = useState(() => localStorage.getItem("kabir_admin_token"));
    const [verified, setVerified] = useState(false);

    useEffect(() => {
        let cancelled = false;
        if (!token) { setVerified(false); return; }
        api.get("/admin/verify")
            .then(() => !cancelled && setVerified(true))
            .catch(() => {
                if (cancelled) return;
                localStorage.removeItem("kabir_admin_token");
                setToken(null);
                setVerified(false);
            });
        return () => { cancelled = true; };
    }, [token]);

    const login = useCallback(async (passcode) => {
        const { data } = await api.post("/admin/login", { passcode });
        localStorage.setItem("kabir_admin_token", data.token);
        setToken(data.token);
        setVerified(true);
        return true;
    }, []);

    const logout = useCallback(() => {
        localStorage.removeItem("kabir_admin_token");
        setToken(null);
        setVerified(false);
    }, []);

    return (
        <AdminAuthCtx.Provider value={{ token, verified, login, logout }}>
            {children}
        </AdminAuthCtx.Provider>
    );
};

export const useAdminAuth = () => useContext(AdminAuthCtx);
